import React, { createContext, useContext, useState, useEffect } from "react";

const ExamStatusContext = createContext();

export const ExamStatusProvider = ({ children }) => {
  const [examStatus, setExamStatus] = useState(() => {
    return localStorage.getItem("examStatus") || "検査前"; // 永続化された値を取得
  });

  useEffect(() => {
    localStorage.setItem("examStatus", examStatus); // 状態を保存
  }, [examStatus]);

  return (
    <ExamStatusContext.Provider value={{ examStatus, setExamStatus }}>
      {children}
    </ExamStatusContext.Provider>
  );
};

export const useExamStatus = () => {
  const context = useContext(ExamStatusContext);
  if (!context) {
    throw new Error("useExamStatus must be used within an ExamStatusProvider");
  }
  return context;
};
